import { TextInput } from '../index';
import React from 'react';
import { Flex } from '@chakra-ui/react';

const ElementRepeated = ({ i, values, first, second, onChange }) => {
	const handleChange = (e) => {
		onChange(e.target.name, e.target.value, i);
	};

	return (
		<Flex alignItems={'center'} gap={10} width={'95%'}>
			<TextInput
				caption={first.caption}
				id={`${first.name}-${i}`}
				name={first.name}
				value={values[i][first.name]}
				type="text"
				onChange={handleChange}
				style={{ width: '50%' }}
				isRequired
			/>
			<TextInput
				caption={second.caption}
				name={second.name}
				type="text"
				value={values[i][second.name]}
				id={`${second.name}-${i}`}
				onChange={handleChange}
				style={{ width: '50%' }}
				isRequired
			/>
		</Flex>
	);
};

export default ElementRepeated;
